module.exports = __webpack_public_path__ + "static/media/image_13.05c3a2df.png";